import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { showAction as showDriverReviewLightbox } from '../../../actions/driver_review_light_box_actions';
import ReactPlaceholder from 'react-placeholder';

function DRRating(props) {
    const [isLoaded, setIsloaded] = useState(false);

    useEffect(() => {
        let counter = 1;
        let clearIntervalFn4 = setInterval(() => {
            if (window.driverreviews || counter >= 20) {
                clearInterval(clearIntervalFn4);
                setIsloaded(true);
            }
            counter += 1;
        }, 100);
    }, []);

    return (
        <div className="product-tile__product-rating" style={{ height: 'auto', marginBottom: '10px' }} onClick={(e) => { _openDriverReviewLightbox(e, props.manufacturer, props.model) }}>
            {
                !isLoaded && (props.manufacturer && props.model) && <>
                    <ReactPlaceholder
                        showLoadingAnimation
                        color="#f5f5f5"
                        type="text"
                        rows={1}
                        style={{ width: 256 }}
                    />
                </>
            }
            {
                isLoaded && props.manufacturer && props.model && <>
                    <div
                        className="driverreviews-widget"
                        data-manufacturer={props.manufacturer}
                        data-model={props.model}
                        data-type="rating"
                    ></div>
                </>
            }
        </div>
    );
}

function _openDriverReviewLightbox(e, manufacturer, model) {
    e.preventDefault();
    if (manufacturer && model) {
        showDriverReviewLightbox({ manufacturer, model });
    }
}

DRRating.propTypes = {
    manufacturer: PropTypes.string,
    model: PropTypes.string,
};

export default DRRating;
